import {Component} from '@angular/core';
import {GnSiteInfo} from '../app-config/SiteInfo';

@Component({
  selector: 'gn-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less']
})
export class GnLayoutComponent {

  constructor(public siteInfo: GnSiteInfo) {
  }

}
